var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oxy-color-input"},[_c('ColorInput',{attrs:{"color-options":_vm.options,"inline":_vm.control.inline,"show-input":!_vm.control.inline,"small":true,"position":"left","show-global":false},model:{value:(_vm.syncedValue),callback:function ($$v) {_vm.syncedValue=$$v},expression:"syncedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }